export default __webpack_public_path__ + "static/media/pszczola.1346426c.svg";